<app-data-set
	#dataSet
	[dataSource]="dataSource"
	defaultPresentationMode="table"
	firstColumnProperty="company.name"
	[rowId]="rowId"
>
	<app-data-set-toolbar>
		<div *appSearchActionGroup style="flex: 1">
			<app-data-set-search
				defaultFilterName="companyName"
				[defaultFilterLabel]="filterLabels.companyName"
				[placeholder]="filterLabels.defaultPlaceholder"
			>
				<div class="filter-grid" [style.--columns]="4">
					<div class="filter-item">
						<mat-form-field subscriptSizing="dynamic" appearance="outline">
							<mat-label>{{ filterLabels.companyName }}</mat-label>
							<input
								matInput
								[ngModel]="dataSet.filter('companyName')"
								(ngModelChange)="dataSet.filter('companyName', filterLabels.companyName, $event)"
								data-automation-id="company-name-input"
							/>
						</mat-form-field>
					</div>
					<div class="filter-item">
						<mat-form-field subscriptSizing="dynamic" appearance="outline">
							<mat-label>{{ filterLabels.relationship }}</mat-label>
							<mat-select
								[ngModel]="dataSet.filter('relationship')"
								data-automation-id="company-relationship-picker"
								(ngModelChange)="dataSet.filter('relationship', filterLabels.relationship, $event, relationshipOptions)"
							>
								@for (option of relationshipOptions; track option; let idx = $index) {
									<mat-option [value]="option.value" [attr.data-automation-id]="'relationship-option-' + idx">{{
										option.label
									}}</mat-option>
								}
							</mat-select>
						</mat-form-field>
					</div>
					<div class="filter-item">
						<mat-form-field subscriptSizing="dynamic" appearance="outline">
							<mat-label>{{ filterLabels.status }}</mat-label>
							<mat-select
								[ngModel]="dataSet.filter('active')"
								(ngModelChange)="dataSet.filter('active', filterLabels.status, $event, activeOptions)"
								data-automation-id="company-status"
							>
								@for (option of activeOptions; track option; let idx = $index) {
									<mat-option [value]="option.value" [attr.data-automation-id]="'company-status-' + idx">{{
										option.label
									}}</mat-option>
								}
							</mat-select>
						</mat-form-field>
					</div>
					<div class="filter-item">
						<mat-form-field subscriptSizing="dynamic" appearance="outline">
							<mat-label>{{ filterLabels.streetAddress }}</mat-label>
							<input
								matInput
								[ngModel]="dataSet.filter('streetAddress')"
								data-automation-id="street-address-input"
								(ngModelChange)="dataSet.filter('streetAddress', filterLabels.streetAddress, $event)"
							/>
						</mat-form-field>
					</div>
				</div>

				<div class="filter-grid" [style.--columns]="4">
					<div class="filter-item">
						<mat-form-field subscriptSizing="dynamic" appearance="outline">
							<mat-label>{{ filterLabels.townCity }}</mat-label>
							<input
								matInput
								[ngModel]="dataSet.filter('locality')"
								data-automation-id="city-input"
								(ngModelChange)="dataSet.filter('locality', filterLabels.townCity, $event)"
							/>
						</mat-form-field>
					</div>
					<div class="filter-item">
						<mat-form-field subscriptSizing="dynamic" appearance="outline">
							<mat-label>{{ filterLabels.stateProvince }}</mat-label>
							<input
								matInput
								[ngModel]="dataSet.filter('stateProvinceRegion')"
								data-automation-id="state-input"
								(ngModelChange)="dataSet.filter('stateProvinceRegion', filterLabels.stateProvince, $event)"
							/>
						</mat-form-field>
					</div>
					<div class="filter-item">
						<mat-form-field subscriptSizing="dynamic" appearance="outline">
							<mat-label>{{ filterLabels.postalCode }}</mat-label>
							<input
								matInput
								[ngModel]="dataSet.filter('postalCode')"
								data-automation-id="postal-code-input"
								(ngModelChange)="dataSet.filter('postalCode', filterLabels.postalCode, $event)"
							/>
						</mat-form-field>
					</div>
					<div class="filter-item">
						<!-- FIXME: FILTER FIXES -  Should be country code drop-down -->
						<mat-form-field subscriptSizing="dynamic" appearance="outline">
							<mat-label>{{ filterLabels.country }}</mat-label>
							<input
								matInput
								[ngModel]="dataSet.filter('countryCode')"
								data-automation-id="country-input"
								(ngModelChange)="dataSet.filter('countryCode', filterLabels.country, $event)"
							/>
						</mat-form-field>
					</div>
				</div>
			</app-data-set-search>
		</div>
	</app-data-set-toolbar>

	<app-data-set-content>
		<app-data-set-table-view>
			@if (loadingService.isLoading(companyLoadingKey) || !finishedLoadingInitData) {
				<app-data-set-loading-row />
			}
			<table
				mat-table
				[dataSource]="dataSource"
				matSort
				[hidden]="loadingService.isLoading(companyLoadingKey) || !finishedLoadingInitData"
			>
				<tr class="mat-row" *matNoDataRow>
					<td class="mat-cell" [colSpan]="displayedColumns.length" i18n="@@dataSetTable-noRecordsFound">
						No records found.
					</td>
				</tr>

				<ng-container matColumnDef="companyName">
					<th mat-header-cell *matHeaderCellDef mat-sort-header i18n="@@companyEntityRelationship-CompanyNameRow">
						Company Name
					</th>
					<td mat-cell *matCellDef="let row">{{ row.company.name }}</td>
				</ng-container>

				<ng-container matColumnDef="relationship">
					<th mat-header-cell *matHeaderCellDef mat-sort-header i18n="@@companyEntityRelationship-Relationship">
						Relationship
					</th>
					<td mat-cell *matCellDef="let row">
						<!-- TODO This needs to be more dynamic (could be more than contractors, clients, etc) -->
						@if (row.entityRelationship.relationshipType === 'contractor') {
							<div
								style="background: #45ba9e"
								class="relationship-rounded-box"
								i18n="@@companyEntityRelationship-Contractor"
							>
								Contractor
							</div>
						} @else {
							<div
								style="background: #4582ba"
								class="relationship-rounded-box"
								i18n="@@companyEntityRelationship-Client"
							>
								Client
							</div>
						}
					</td>
				</ng-container>

				<ng-container matColumnDef="address">
					<th mat-header-cell *matHeaderCellDef mat-sort-header i18n="@@companyEntityRelationship-AddressRow">
						Address
					</th>
					<td mat-cell *matCellDef="let row">
						<div style="display: flex; flex-direction: column">
							@if (row.company.address) {
								<div [innerHtml]="row.company.address | address"></div>
							}
						</div>
					</td>
				</ng-container>

				<ng-container matColumnDef="active">
					<th mat-header-cell *matHeaderCellDef mat-sort-header i18n="@@companyEntityRelationship-StatusHeader">
						Status
					</th>

					<td mat-cell *matCellDef="let row">
						@if (row.company.active) {
							<span i18n="@@companyEntityRelationship-Active">Active</span>
						}
						@if (!row.company.active) {
							<span i18n="@@companyEntityRelationship-Inactive">Inactive</span>
						}
					</td>
				</ng-container>

				@if (isOracle) {
					<ng-container matColumnDef="slugId">
						<th mat-header-cell *matHeaderCellDef mat-sort-header i18n="@@companyEntityRelationship-SlugIdRow">
							SLUGID
						</th>
						<td mat-cell *matCellDef="let row">
							<div style="display: flex; flex-direction: column">
								@if (row.company.slugId) {
									<div [innerHtml]="row.company.slugId"></div>
								}
							</div>
						</td>
					</ng-container>
				}

				<tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
				<tr
					mat-row
					*matRowDef="let row; columns: displayedColumns"
					(appDataSetRowClick)="onRowClick(row)"
					[attr.data-automation-id]="'company-entity-' + row.id + '-row'"
				></tr>
			</table>
		</app-data-set-table-view>
	</app-data-set-content>
</app-data-set>
